import Phrase from 'libs/translationsUtils/phrase'
import SearchResultsSection from './SearchResultsSection'
import HitContainerHeader from './HitContainerHeader'

const HitContainer = ({ allSearchResults, inputValue, hits, doSearch, highlightedIndex, getItemProps, style }) =>
  <div key='results' className='algolia-hit-container' style={style}>
    <HitContainerHeader
      inputValue={inputValue}
      hasResults={hits.length > 0}
      doSearch={doSearch}
    />

    <SearchResultsSection
      searchResults={allSearchResults}
      hits={hits}
      highlightedIndex={highlightedIndex}
      getItemProps={getItemProps}
      previousResultsCount={0}
    />

    <a className='link algolia-search__createTopic' href='/topic/new'>
      <Phrase p='live.search.ask.question' />
    </a>
  </div>

export default HitContainer
